import React from 'react'

import styled from 'styled-components'
import useSWR from 'swr'

import {PSmall} from '@festi/common/components/typography'
import {styledTheme} from '@festi/common/themes'

import {pagoTermsAndConditions} from '../api/fetch'

const TermsContainer = styled.div`
  padding: 24px;
  border-radius: 12px;
  background-color: ${styledTheme.palette.backgroundGrey};
`

// TODO: Remove this component when the iframe is implemented
export default function PagoTerms() {
  const {data: termsData} = useSWR(
    'terms-and-conditions',
    pagoTermsAndConditions,
  )

  if (!termsData?.content) return null

  return <RichTextRenderer jsonString={termsData?.content} />
}

interface RichTextChild {
  text: string
}

interface RichTextNode {
  type: string
  children: RichTextChild[]
}

interface RichTextProps {
  jsonString: string
}

const RichTextRenderer: React.FC<RichTextProps> = ({jsonString}) => {
  let parsedData: RichTextNode[] = []
  try {
    parsedData = JSON.parse(jsonString)
  } catch (error) {
    console.error('Error parsing JSON:', error)
  }

  return (
    <TermsContainer>
      {parsedData.map((node, nodeIndex) => {
        if (node.type === 'paragraph') {
          return (
            <PSmall key={nodeIndex}>
              {node.children.map((child, childIndex) =>
                child.text ? (
                  <span key={childIndex}>{child.text}</span>
                ) : (
                  <br key={childIndex} />
                ),
              )}
            </PSmall>
          )
        }
        return null
      })}
    </TermsContainer>
  )
}
